const page = require('../../../../../components/page/page')
const transactionDt = require('./transaction-dt')
const pageChart = require('./transaction-page-chart')
const navmenu = require('../../../../../components/navmenu/navmenu')

import transactionPage from "./transaction-page.html";

/****************ELEMENTS*****************/
var HTMLwasSelected = false

//insert the page  on the body
function HTMLselect(detail) { //console.log('transaction init>')

   HTMLwasSelected = true

   //load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", transactionPage)

   transactionDt.start({ "dest": "transaction", "elem": "dt", "act": "select", "entity": "transaction" })
   navmenu.start({
      act: 'renderNavMenu',
      container: '#print-menu-container',
      items: [
         {
            label: 'Acc. receivable',
            icon: 'print',
            dest: 'accountsReceivable',
            action: 'printReport',
            extraData: { entity: 'customer', reportName: 'account-receivable-all' }
         },
         {
            label: 'Acc. payable',
            icon: 'print',
            dest: 'accountsPayable',
            action: 'printReport',
            extraData: { entity: 'provider', reportName: 'account-payable-all' }
         },
         {
            label: 'Financial Reports', // Padre con desplegable
            icon: 'report',
            submenu: [
               {
                  label: 'Acc. receivable',
                  icon: 'print',
                  dest: 'accountsReceivable',
                  action: 'printReport',
                  extraData: { entity: 'customer', reportName: 'account-receivable-all' }
               },
               {
                  label: 'Acc. payable',
                  icon: 'print',
                  dest: 'accountsPayable',
                  action: 'printReport',
                  extraData: { entity: 'provider', reportName: 'account-payable-all' }
               }
            ]
         }
      ]
   })
   pageChart.start({ act: 'createAllChart' })

}/*init*/

/****************ELEMENTS*****************/

export function start(detail) { //console.log('transaction page >', detail)

   if (!HTMLwasSelected) { HTMLselect(detail) }

   obj[detail.act].start(detail)
}

const obj = {

   show: { start: (detail) => { page.start(detail) } },
   searchbydate: { start: (detail) => { pageChart.searchbydate() } },
   searchbybutton: { start: (detail) => { pageChart.searchbybutton(detail) } }

}/**/